import { useEffect, useState } from 'react'
import { Route, Routes } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { SpinnerLoader } from 'shared/ui'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { RcsRoutes } from 'pages/settings/pages/rcs/route/type'
import { RcsPage } from 'pages/settings/pages/rcs/ui/RcsPage'
import { RcsCreate } from 'pages/settings/pages/rcs/ui/RcsCreate'
import { RcsV2Router } from 'pages/settings/pages/rcsV2/route/RcsV2Router'

export const RcsRouter = observer(() => {
  const [loading, setLoading] = useState(true)
  const { featureFlagsStore } = useEntitiesContext()

  useEffect(() => {
    featureFlagsStore.fetchFeatureFlags().then(() => setLoading(false))
  }, [])

  if (loading) return <SpinnerLoader ariaLabel={'RcsRouter'} />

  if (featureFlagsStore.rcs_compliance_v2) return <RcsV2Router />

  return (
    <Routes>
      <Route index element={<RcsPage />} />
      <Route path={`${RcsRoutes.create}/*`} element={<RcsCreate />} />
    </Routes>
  )
})
